/**
 * Tracks transient overlays that sit *above* a dialog.
 *
 * Escape has to close the topmost thing only. Radix's Dialog listens for it in
 * the capture phase, and it mounts first, so a lightbox opened later cannot win
 * by calling `stopPropagation()` — its listener simply runs second. Pressing
 * Escape over an enlarged screenshot would close the whole task.
 *
 * So the dialog asks instead: if something is stacked on top of it, it declines
 * the key and lets that thing close itself.
 */

let depth = 0;
const listeners = new Set<() => void>();

export function pushOverlay(): () => void {
  depth += 1;
  notify();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    depth = Math.max(0, depth - 1);
    notify();
  };
}

/** Whether anything is stacked above the dialog layer. */
export function hasOverlayAbove(): boolean {
  return depth > 0;
}

export function subscribeOverlay(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function notify(): void {
  for (const listener of listeners) listener();
}
